/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForServiceAccountFeaturePropagation extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForServiceAccountFeaturePropagation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForServiceAccountFeaturePropagation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForServiceAccountFeaturePropagation>): BackgroundJobPayloadForServiceAccountFeaturePropagation {
        let obj = Object.assign(new BackgroundJobPayloadForServiceAccountFeaturePropagation(), model);
        BackgroundJobPayloadForServiceAccountFeaturePropagation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForServiceAccountFeaturePropagation>): BackgroundJobPayloadForServiceAccountFeaturePropagation {
        if (!model) return null;
        return BackgroundJobPayloadForServiceAccountFeaturePropagation.newInstance(<BackgroundJobPayloadForServiceAccountFeaturePropagation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForServiceAccountFeaturePropagation) {
        if (!obj) return;

        models.BackgroundJobPayloadForServiceAccountFeaturePropagation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForServiceAccountFeaturePropagation): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForServiceAccountFeaturePropagation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Feature for the account
     */
    feature: models.ServiceAccountFeature;

    /**
     * The desired status of the service account feature propagation
     */
    desired_status: models.ServiceAccountFeatureStatus;

}
